import {req} from './requestHelper';
import jwt from 'jsonwebtoken';
import {SystemKey, TOKEN_KEY} from '../constants';

const defaultAuthInfo = {claims: [], userId: '', email : '', name : '', identityType: ''};

export async function login(cred) {
    try {
        const res = await req('/api/login', {
            method: 'post',
            data: {...cred, systemKey : SystemKey}
        });
        const {success, token} = res.data;
        setAuth(success ? token : undefined);
    } catch (e) {
        setAuth(undefined);
    }
    return getAuth();
}

export function logout() {
    clearAuth();
}

export const getAuth = () => {
    const token = getAuthToken();
    if (token) {
        const {claims = [], userId = '', email = '', name= '', identityType = ''} = jwt.decode(token);
        //過期
        if (isTokenExpired(token)) {
            clearAuth();
            return defaultAuthInfo;
        }
        return {claims, userId, email, name, identityType}
    }
    return defaultAuthInfo;
};

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);

export const clearAuth = () => {
    if(getAuthToken()){
        localStorage.removeItem(TOKEN_KEY);
    }
};

export const setAuth = token => {
    localStorage.removeItem(TOKEN_KEY);
    if (token) {
        localStorage.setItem(TOKEN_KEY, token);
    }
};

const isTokenExpired = token => {
    const {exp} = jwt.decode(token);
    const currentTime = Date.now().valueOf() / 1000;
    return !exp || exp < currentTime;
};
